import {REHYDRATE} from 'redux-persist/lib/constants';

import * as actionTypes from '@actions/actionTypes';
import {mergeRehydrate} from '@reducers/rehydrateUtils';

const initialState = {};

const messageReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SAVE_MESSAGE_BOX : {
            return {
                ...state,
                [action.data.name]: {...action.data},
            };
        }

        case actionTypes.CLEAR_MESSAGE_BOX : {
            const newState = {...state};
            delete newState[action.data.name];

            return newState;
        }

        case actionTypes.SET_CLOSED_TIMESTAMP: {
            return {
                ...state,
                closedDatetimes: {
                    ...state.closedDatetimes,
                    [action.data.name]: action.data.timestamp,
                },
            };
        }

        case REHYDRATE: {
            const closedDatetimes = mergeRehydrate(
                action,
                'payload.messages.closedDatetimes',
                null
            );

            if (!closedDatetimes) {
                return state;
            }

            return {
                ...state,
                closedDatetimes: {
                    ...state.closedDatetimes,
                    ...closedDatetimes,
                },
            };
        }

        default:
            return state;
    }
};

export default messageReducer;
